export const Created = 'created' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Created = typeof Created

export const Held = 'held' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Held = typeof Held

export type CoinsType = Created | Held

export const all = [Created, Held]
